module.exports = __webpack_public_path__ + "img/68.712dcda3.jpg";